<template>
    <div :class="{'opacity-50': isEmpty}">
        <h2 class="hidden lg:block mt-8 mb-2 uppercase font-semibold text-base text-grey-dark">Chart Type</h2>
        <div class="py-4 lg:px-0 px-4 flex-row flex-no-wrap lg:flex-wrap flex items-stretch">
            <image-button
                    v-for="foo in chartTypes"
                    @click.native="updateChart(foo)"
                    :active="isActive(foo)"
                    :img="'/images/charts/' + foo.img"
                    :key="foo.img"
            >
                {{ foo.description }}
            </image-button>
        </div>
    </div>
</template>

<script>
    import ImageButton from "../components/ImageButton";

    export default {
        components: {ImageButton},
        computed: {
            isEmpty() {
                return this.$store.getters.isEmpty;
            },
            chartTypes() {
                return this.$store.state.chart.chartTypes;
            }
        },
        methods: {
            isActive(foo) {
                return foo.type === this.$store.state.type
                    && foo.stacking === this.$store.state.stacking;
            },
            select(item) {
                this.active = item;
            },
            updateChart(items) {
                this.$store.dispatch('updateChart', items);
            },
        },
    }

</script>
